import styled, { css } from 'styled-components';
import { paddings, zModal, borderRadius, mediaQuery } from '~/styled';

export interface ModalContentProps {
  $stickyFooter?: boolean;
  $newStyle?: boolean;
}

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zModal};
  .CloseIcon {
    position: absolute;
    top: ${paddings.tinyPadding};
    right: ${paddings.tinyPadding};
    color: ${({ theme }) => theme.colors.grey400};
    cursor: pointer;
    transition: color ease 0.2s;
  }
`;
export const ModalOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.grey800};
  opacity: 0.2;
  transition: background 0.3s linear;
`;

export const ModalContent = styled.div<ModalContentProps>`
  position: absolute;
  background: ${({ theme }) => theme.colors.surface};
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  max-width: calc(100% - 32px);
  max-height: 100%;
  min-width: 350px;
  ${(props) =>
    props.$newStyle &&
    css`
      border-radius: ${borderRadius.default};
    `}
  ${(props) =>
    props.$stickyFooter &&
    css`
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    `}
    .CloseIcon {
    right: 1rem;
    top: 1rem;
  }
  ${mediaQuery.down.s`
    min-width: unset;
    width: 100%;
    height: 100%;
    max-width:unset;
    border-radius: 0;
  `}
`;
